import React from 'react';
import { Users } from 'lucide-react';
import { CsvImportDialog } from '../CsvImportDialog';

interface ImportedUsersEmptyStateProps {
  searchTerm: string;
}

export const ImportedUsersEmptyState = ({ searchTerm }: ImportedUsersEmptyStateProps) => {
  return (
    <div className="text-center py-8">
      <Users className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
      <h3 className="text-lg font-semibold mb-2">
        {searchTerm ? 'No matching records found' : 'No import records found'}
      </h3>
      <p className="text-muted-foreground mb-4">
        {searchTerm ? 'Try adjusting your search terms' : 'Import users via CSV to see them here for processing'}
      </p>
      <div className="flex gap-2 justify-center">
        <CsvImportDialog />
      </div>
    </div>
  );
};